<div class = "body">
    
    <div class = "afiliado" *ngIf = "rol == 'ROLE_ADMINISTRADOR' || rol == 'ROLE_CONTABILIDAD' || rol == 'ROLE_ENCARGADO_CONTABILIDAD' || rol == 'ROLE_COORDINADOR'">

        <div class = "container" style = "height:100px"> </div>

        <div class = "container" id = "tabla" style = "background-color: white; padding-top: 50px; padding-bottom:50px">

            <div class = "row">

                <div class = "col-lg-6"> <h1> Postulaciones Disponibles para Pago </h1> </div>
                
                <div class = "col-lg-3"> </div>

                <div class = "col-lg-2"> <h3> Cantidad de Registros </h3> </div>

                <div class = "col-lg-1">

                    <select class = "form-control" (change) = "cambiaCantidadRegistros()" [(ngModel)] = "config.itemsPerPage">
          
                        <option value = "10">10</option>
                        <option value = "20">20</option>
                        <option value = "30">30</option>
                        <option value = "50">50</option>
                        <option value = "100">100</option>
                        
                    </select> </div>

            </div> <hr/> <br/> 

            <div class = "row">

                <div class = "col-lg-1"> <h3> Productos: </h3> </div>
                                
                <div class = "col-lg-2">

                    <select class = "form-control" [(ngModel)] = "idProducto" (change) = "loadData()">
                        
                        <option *ngFor = "let producto of agrupadorProductos" value = {{producto.id}}> 
                            
                            {{producto.descripcion}} 

                        </option>
                        
                    </select> 
                
                </div>
                
                <div class = "col-lg-1"> </div>

                <div class = "col-lg-2"> <h3> Fecha Pago Grupo:</h3> </div> 
                                
                <div class = "col-lg-2">
                 
                    <input class = "form-control" [(ngModel)] = "fechaPagoGrupo" type = "date" min="{{currentDate | date:'yyyy-MM-dd'}}"/>
                
                </div>

                <div class = "col-lg-1"> </div>

                <div class = "col-lg-3"> <button class = "btn btn-success" (click) = "enviarPostulacionesSeleccionadas()"> 
                    
                    <i class = "fa fa-plus"></i> Crear Grupo Pago </button> 
            
                </div>


                <div *ngIf = "this.idProducto==2" class = "col-lg-2"> <h3> Total seleccionado: </h3> </div> 
                                
                <div *ngIf = "this.idProducto==2" class = "col-lg-3">
                    <input class = "form-control"  
                     name = "totalizado" 
                     matInput
                     disabled
                     [(ngModel)]="totalizado"
                     (input)="totalizado()"
                     type="text">    
                                     
                </div>

            </div> <br/> <br/> 

            <div class = "row">

                <div class = "col-lg-4"> 
                    <h3> <mat-checkbox color = "primary" [checked] = "allComplete" [indeterminate] = "someComplete()"
                    (change) = "setAll($event.checked)"> Seleccionar Todo </mat-checkbox> </h3> 
                </div>

                <div class = "col-lg-2"> <h3> Fecha Contable:</h3> </div> 
                                
                <div class = "col-lg-2">
                 
                    <input class = "form-control" [(ngModel)] = "fechaContable" type = "date" />
                
                </div>

                <div class = "col-lg-7"> 
                    
                </div>

            </div> 

            <div class = "table-responsive">

                <table class = "table" style = "width:100%;">
                
                    <thead style = "background-color: #0f69b4;color:white;    width:100%;">
                    
                        <tr>
                            <th> </th>

                            <th scope = "col"> N° </th>

                            <th scope = "col"> Rut Titular </th>

                            <th scope = "col"> Nombre y Apellido Titular</th>

                            <th scope = "col"> Rut Beneficiario </th>

                            <th scope = "col"> Nombre y Apellido Beneficiario</th>
                           
                            <th scope = "col"> Fecha Ingreso </th>

                            <th scope = "col"> Fecha Modificación </th>
                            
                            <th scope = "col"> Producto </th>

                            <th scope = "col"> Tipo de Producto </th>
                           
                            <th *ngIf ="this.idProducto==2" scope = "col">Monto Reembolso </th>
                            <th *ngIf ="this.idProducto==4" scope = "col">Monto</th>
                            <th scope = "col"> Estado </th>

                            <th scope = "col"> Ver Archivo </th>
                        </tr>

                    </thead>
                    
                    <tbody>
                       
                        <tr class = "tablaPostulaciones" *ngFor = "let postulacion of postulaciones | paginate: config">
                            
                            <td>
                                <div *ngIf ="this.idProducto==2 else actualizadorTotal">
                                    <mat-checkbox [(ngModel)] = "postulacion.seleccionado" color = "primary" 
                                    (ngModelChange) = "updateAllComplete()"  (change)="actualizaTotal(postulacion)"> </mat-checkbox>
                                </div> 
                                <ng-template #actualizadorTotal>
                                    <mat-checkbox [(ngModel)] = "postulacion.seleccionado" color = "primary" 
                                    (ngModelChange) = "updateAllComplete()"> </mat-checkbox>
                                </ng-template>                             

                            </td> 
                            <td> {{postulacion.id}} </td>

                            <td> {{postulacion.rutTitular}} </td>
                            
                            <td> {{postulacion.nombreTitular}} </td>

                            <td> {{postulacion.rut}} </td>
                            
                            <td> {{postulacion.nombreCompleto}} </td>                        

                            <td> {{postulacion.fechaCreacion}} </td>

                            <td> {{postulacion.fechaModificacion}} </td>
                            
                            <td> {{postulacion.nombreProducto}} </td>                        

                            <td> {{postulacion.categoriaProducto}} </td>
                            
                            <td *ngIf = "postulacion.nombreProducto == 'REEMBOLSO'"> ${{postulacion.montoReembolso}} </td>
                            <td *ngIf = "postulacion.nombreProducto == 'AYUDA MEDICA'"> ${{postulacion.montoReembolso}} </td>
                            <td> {{postulacion.estado}} </td>

                            <td> <button class = "btn btn-info" (click) = "verArchivo(postulacion.id)"> 
                                    
                                <i class = "fa fa-search"> </i> Ver 
                                
                            </button> </td>
                        
                        </tr>
                    
                    </tbody>
                
                </table> <br/>

                <pagination-controls style = "text-align: center" previousLabel = "Anterior" nextLabel = "Siguiente" 
                (pageChange) = "pageChanged($event)" autoHide = "true"> </pagination-controls>
                            
            </div>

        </div>
        
        <div class = "container" style = "height:100px"> </div>
    
    </div>

</div>